import * as React from "react";
import { EnvironmentsTable } from "./EnvironmentsTable";
import type { IEnvironment } from "../../../types/EnvironmentTypes";
import { IBackendImage } from "../../../services/registry/BackendImageService";

export interface TableTabPanelProps {
  environments: IEnvironment[];
  backendImages: IBackendImage[];
  selectedItem: IEnvironment | undefined;
  setSelectedItem: React.Dispatch<React.SetStateAction<IEnvironment | undefined>>;
  onNewButtonClick: () => void;
  onRefreshButtonClick: () => void;
  onPageChange: (page: number, rowsPerPage: number, visibleRows: IEnvironment[]) => void;
  initialFilterQuery: string;
}

export const TableTabPanel = ({
  environments,
  backendImages,
  selectedItem,
  setSelectedItem,
  onNewButtonClick,
  onRefreshButtonClick,
  onPageChange,
  initialFilterQuery,
}: TableTabPanelProps) => {
  return (
    <>
      <EnvironmentsTable
        rows={environments}
        backendImages={backendImages}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        onNewButtonClick={onNewButtonClick}
        onRefreshButtonClick={onRefreshButtonClick}
        onPageChange={onPageChange}
        initialFilterQuery={initialFilterQuery}
      />
    </>
  );
};
